<template>
  <div id="slate-int-back-button">
    <span v-on:click="backButtonClick" class="internal"><a>« Back</a></span>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  methods: {
    backButtonClick () {
      this.$emit('backButtonClick')
    }
  }
}
</script>

<style scoped>
#slate-int-back-button {
  text-align: left;
  width: 100%;
}
.internal {
  cursor: pointer;
}
.internal:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// BackButton.vue?36ce659d